<template>
  <div class="reward-page page-padding-top">
    <top-bar :title="i18n.t('reward.title')" @back="back"></top-bar>

    <div class="top-info flex-column-start-center">
      <div class="title">{{$t('reward.desc1')}}</div>
      <div class="sub-title">{{$t('reward.desc2')}}</div>
    </div>

    <div class="reward-box">
      <div class="title">{{$t('reward.label1')}}</div>
      <div class="flex">
        <div class="flex-1 flex-column-center" :class="item.status == 1 ? 'active' : ''" v-for="(item, i) in rewardList1" :key="i">
          <div class="count">+{{item.RewardAmount}}USDT</div>
          <div class="icon">
            <img :src="coinUrl" alt="" v-if="item.status != 1">
            <img :src="coinUrl2" alt="" v-else>
          </div>
          <div class="line"></div>
          <div class="label">{{$t('reward.label2')}}</div>
          <div class="number">{{item.TradeVolume}} USDT</div>
        </div>
      </div>
    </div>

    <div class="reward-box">
      <div class="title">{{$t('reward.label3')}}</div>
      <div class="flex">
        <div class="flex-1 flex-column-center" :class="item.status == 1 ? 'active' : ''" v-for="(item, i) in rewardList2" :key="i">
          <div class="count">+{{item.RewardAmount}}USDT</div>
          <div class="icon">
            <img :src="coinUrl" alt="" v-if="item.status != 1">
            <img :src="coinUrl2" alt="" v-else>
          </div>
          <div class="line"></div>
          <div class="label">{{$t('reward.label2')}}</div>
          <div class="number">{{item.TradeVolume}} USDT</div>
        </div>
      </div>
    </div>

    <div class="desc-title">{{$t('reward.label4')}}</div>
    <div class="desc">{{$t('reward.content')}}</div>
  </div>
</template>
<script>
import { rewardList, rewardLog } from '@/api/index'
import topBar from '@/components/topBar'
import moment from 'moment'
export default {
  components: {
    topBar
  },
  data() {
    return {
      coinUrl: require('../../assets/imgs/icon-coin.png'),
      coinUrl2: require('../../assets/imgs/icon-coin2.png'),
      isInit: false,
      finishedText: '',
      logList: [],
      isLogInit: false,
      isListInit: false,
      rewardList1: [],
      rewardList2: []
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    back() {
      this.$router.go(-1)
    },
    init() {
      let form = new FormData()
      form.append('Start', moment().format('YYYY-MM-DD') + ' 00:00:00')
      rewardLog(form).then(res => {
        this.isLogInit = true
        this.logList = res.data.Items
        if (this.isListInit) {
          this.resetData()
        }
      })


      let form2 = new FormData()
      form2.append('pageSize', 30)
      rewardList(form2).then(res => {
        let list = res.data.Items
        this.isListInit = true
        this.rewardList1 = list.filter(v => {
          return v.TradeType == 'option'
        }).sort((a, b) => {
          return a.TradeVolume - b.TradeVolume
        })
        this.rewardList2 = list.filter(v => {
          return v.TradeType == 'contract'
        }).sort((a, b) => {
          return a.TradeVolume - b.TradeVolume
        })
        if (this.isLogInit) {
          this.resetData()
        }
      })
    },
    resetData() {
      this.rewardList1.forEach(v => {
        let index = this.logList.findIndex(val => {
          return v.ID == val.RewardSettingsID
        })
        if (index > -1) {
          v.statue = 1
        }
      })
      this.rewardList2.forEach(v => {
        let index = this.logList.findIndex(val => {
          return v.ID == val.RewardSettingsID
        })
        if (index > -1) {
          v.statue = 1
        }
      })
    }
  }
}
</script>